import React from 'react';
import Link from 'src/shared/components/Link';
import RoutePaths from 'src/config/RoutePaths';

import Message from 'src/shared/config/Message';
import FieldTitle from '../components/FieldTitle';

import styles from '../styles.module.scss';

const getStepOneFields = (t, locale) => {
    const [pICheckboxStatementPrefix, pICheckboxStatementPostfix] = t('pi_checkbox_statement', {
        'professional investor': '__placeholder__',
    }).split('__placeholder__');

    const [agreementPrefix, agreementMiddle, agreementPostfix] = t('agreement_checkbox_statement', {
        'Terms and Conditions': '__tnc-placeholder__',
        'Privacy Policy': '__pp-placeholder__',
    }).split(/__tnc-placeholder__|__pp-placeholder__/);

    return [
        {
            controlId: 'firstName',
            beforeRenderer: <FieldTitle title={t('form_name')} />,
            label: t('form_first_name'),
            type: 'text',
            autoComplete: 'given-name',
            readOnly: false,
            validate: [
                {
                    required: true,
                    message: t(Message.FIELD_REQUIRED),
                },
                {
                    english: true,
                    message: t(Message.ENGLISH_ONLY),
                },
            ],
        },
        {
            controlId: 'lastName',
            label: t('form_last_name'),
            type: 'text',
            autoComplete: 'family-name',
            readOnly: false,
            validate: [
                {
                    required: true,
                    message: t(Message.FIELD_REQUIRED),
                },
                {
                    english: true,
                    message: t(Message.ENGLISH_ONLY),
                },
            ],
        },
        {
            controlId: 'email',
            beforeRenderer: <FieldTitle title={t('login_email')} />,
            label: t('login_email'),
            type: 'email',
            autoComplete: 'email',
            readOnly: false,
            validate: {
                email: true,
                required: true,
                message: t(Message.EMAIL_REQUIRED),
            },
        },
        {
            controlId: 'phone',
            beforeRenderer: <FieldTitle title={t('form_mobile')} description={t('form-mobile-description')} />,
            label: t('form_mobile'),
            type: {
                name: 'phoneNumber',
                locale,
            },
            autoComplete: 'tel-local',
            readOnly: false,
            validate: {
                phoneNumberRequired: true,
                phoneCodeRequired: true,
                message: t(Message.FIELD_REQUIRED),
            },
            maxMenuHeight: 250,
        },
        {
            controlId: 'isProfessional',
            type: 'checkbox',
            label: (
                <div className={styles.checkboxStatement}>
                    {pICheckboxStatementPrefix}
                    <Link href={RoutePaths.PROFESSIONAL_INVESTOR_NOTICE}>
                        <a className={styles.agreement} target="_blank">
                            {t('professional investor')}
                        </a>
                    </Link>
                    {pICheckboxStatementPostfix}
                </div>
            ),
            validate: {
                required: true,
                message: t(Message.FIELD_REQUIRED),
            },
            className: styles.checkbox,
            placeholder: '',
            containerClassName: styles.firstCheckboxFieldContainer,
        },
        {
            controlId: 'agreeNdaAndPrivacy',
            type: 'checkbox',
            label: (
                <div className={styles.checkboxStatement}>
                    {agreementPrefix}
                    <Link href={RoutePaths.TERMS_AND_CONDITIONS}>
                        <a className={styles.agreement} target="_blank">
                            {t('terms_and_conditions')}
                        </a>
                    </Link>
                    {agreementMiddle}
                    <Link href={RoutePaths.PRIVACY_POLICY}>
                        <a className={styles.agreement} target="_blank">
                            {t('menu_privacy_policy')}
                        </a>
                    </Link>
                    {agreementPostfix}
                </div>
            ),
            validate: {
                required: true,
                message: t(Message.FIELD_REQUIRED),
            },
            className: styles.checkbox,
            containerClassName: styles.lastCheckboxFieldContainer,
        },
    ];
};

export default getStepOneFields;
